/* GLPro Core landing page — assets/glpro-core.js
   Loaded by layout/glpro-landing.liquid. Checkout URLs come from the section settings
   (Online Store > Themes > Customize > GLPro Core landing). */
document.addEventListener('DOMContentLoaded',function(){
(function(){
  /* ---------- Countdown: 5-hour evergreen, persisted per visitor ---------- */
  var KEY='glpro_cd_end', span=5*3600*1000, end;
  try{end=parseInt(localStorage.getItem(KEY)||'0',10);}catch(e){end=0}
  if(!end||end<Date.now()){end=Date.now()+span;try{localStorage.setItem(KEY,String(end));}catch(e){}}
  var h=document.querySelector('[data-cd="h"]'),m=document.querySelector('[data-cd="m"]'),s=document.querySelector('[data-cd="s"]');
  function pad(n){return (n<10?'0':'')+n}
  function tick(){var d=Math.max(0,end-Date.now());var hh=Math.floor(d/3600000),mm=Math.floor(d%3600000/60000),ss=Math.floor(d%60000/1000);h.textContent=pad(hh);m.textContent=pad(mm);s.textContent=pad(ss);var fbc=document.getElementById('fbCd');if(fbc)fbc.textContent=pad(hh)+':'+pad(mm)+':'+pad(ss);if(d<=0){end=Date.now()+span;try{localStorage.setItem(KEY,String(end));}catch(e){}}}
  tick();setInterval(tick,1000);

  /* ---------- Tier selection (hero card + offer block kept in sync) ---------- */
  var tiers={21:{p:'SGD\u00a0$130',mo:'SGD\u00a0$186/mo',d:'SGD\u00a0$6.19',n:'The 1-Month Starter Pack',days:'21 days · SGD\u00a0$6.19 a day · free delivery',cta:'Get my 1-Month Starter Pack · SGD\u00a0$130'},
             84:{p:'SGD\u00a0$505',mo:'SGD\u00a0$180/mo',d:'SGD\u00a0$6.01',n:'The 3-Months Metabolic Reset System',days:'3 months · SGD\u00a0$6.01 a day · free delivery',cta:'Start my 3-Months Metabolic Reset System · SGD\u00a0$505'},
             189:{p:'SGD\u00a0$984',mo:'SGD\u00a0$156/mo',d:'SGD\u00a0$5.21',n:'The 6-Month Maintain Results',days:'189 days · SGD\u00a0$5.21 a day · free delivery',cta:'Start The 6-Month Maintain Results · SGD\u00a0$984'}};
  var stack=document.getElementById('stack84'),pay=document.getElementById('payNow'),sticky=document.getElementById('stickyPrice'),offerCta=document.getElementById('offerCta');
  function setTier(v){
    var t=tiers[v];
    document.querySelectorAll('input[name="tier"],input[name="tier2"]').forEach(function(i){i.checked=(i.value===String(v));});
    document.querySelectorAll('.opt').forEach(function(o){o.classList.toggle('sel',o.querySelector('input').value===String(v));});
    
    if(sticky)sticky.innerHTML=t.p+'<small>'+t.days+'</small>';
    offerCta.lastChild.textContent=t.cta;
    var hc=document.querySelector('#heroCta span'); if(hc)hc.textContent=t.cta;
  }
  document.querySelectorAll('input[name="tier"],input[name="tier2"]').forEach(function(i){i.addEventListener('change',function(){setTier(this.value)})});

  /* ---------- Carousels ---------- */
  document.querySelectorAll('.car').forEach(function(c){
    var tr=c.querySelector('.car__track');if(!tr)return;
    var p=c.querySelector('[data-prev]'),n=c.querySelector('[data-next]');
    function step(){var f=tr.firstElementChild;return f?f.getBoundingClientRect().width+18:320}
    if(p)p.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'})});
    if(n)n.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'})});
  });

  /* ---------- Timeline tabs ---------- */
  var tabs=document.querySelectorAll('[data-tab]'),panels=document.querySelectorAll('[data-panel]');
  tabs.forEach(function(t){t.addEventListener('click',function(){
    tabs.forEach(function(x){x.setAttribute('aria-selected','false')});this.setAttribute('aria-selected','true');
    var i=this.getAttribute('data-tab');panels.forEach(function(p){p.setAttribute('aria-hidden',p.getAttribute('data-panel')!==i)});
  })});

  /* ---------- KGC year jump ---------- */
  var kt=document.getElementById('kgcTrack');
  document.querySelectorAll('[data-jump]').forEach(function(b){b.addEventListener('click',function(){
    document.querySelectorAll('[data-jump]').forEach(function(x){x.setAttribute('aria-pressed','false');x.removeAttribute('style')});
    this.setAttribute('aria-pressed','true');this.style.background='#00AABB';this.style.color='#fff';
    var card=kt.children[+this.getAttribute('data-jump')];if(card)kt.scrollTo({left:card.offsetLeft-kt.offsetLeft,behavior:'smooth'});
  })});

  /* ---------- Checkout links: one express URL per tier (replace with real URLs) ---------- */
  var ROOT=document.getElementById('glpro-lp')||document.body;
  var CHECKOUT={'21':ROOT.getAttribute('data-checkout-21')||'https://checkout.fitwithlimfelix.com/sg/en-US/express/glprocore-1mo',
                '84':ROOT.getAttribute('data-checkout-84')||'https://checkout.fitwithlimfelix.com/sg/en-US/express/glprocore-3mo',
                '189':ROOT.getAttribute('data-checkout-189')||'https://checkout.fitwithlimfelix.com/sg/en-US/express/glprocore-6mo'};
  var PRICE={'21':130,'84':505,'189':984};
  var current='84';
  function setCheckout(v){
    current=String(v);
    document.querySelectorAll('[data-checkout]').forEach(function(el){var k=el.getAttribute('data-checkout-fixed')||current;el.setAttribute('href',CHECKOUT[k]||CHECKOUT['84']);});
    /* the button says what the selected tier costs, so the price he agreed to is on screen when he commits */
    document.querySelectorAll('[data-buy-label]').forEach(function(l){l.textContent='Proceed to checkout · '+tiers[current].p;});
  }
  var _setTier=setTier; setTier=function(v){_setTier(v);setCheckout(v);};
  document.querySelectorAll('input[name="tier"],input[name="tier2"]').forEach(function(i){i.addEventListener('change',function(){setCheckout(this.value)})});
  setCheckout('84');

  /* ---------- Buttons that point to #offer flash the tier picker ---------- */
  document.querySelectorAll('a[href="#offer"]').forEach(function(a){a.addEventListener('click',function(){
    var o=document.getElementById('opts');if(!o)return;o.classList.remove('opts--flash');void o.offsetWidth;setTimeout(function(){o.classList.add('opts--flash')},450);
  })});

  /* ---------- Live delivery date: 2 working days, 3 p.m. SGT cut-off, no Sunday dispatch ---------- */
  (function(){
    var CUTOFF=15, TZ=8, DAYSN=2;
    var DN=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], MN=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'], shown='';
    function sg(){var d=new Date();return new Date(d.getTime()+d.getTimezoneOffset()*60000+TZ*3600000)}
    function eta(){var now=sg();var d=new Date(now.getFullYear(),now.getMonth(),now.getDate());
      if(now.getHours()>=CUTOFF||d.getDay()===0)d.setDate(d.getDate()+1);
      while(d.getDay()===0)d.setDate(d.getDate()+1);
      var a=0;while(a<DAYSN){d.setDate(d.getDate()+1);if(d.getDay()===0)continue;a++}return d}
    function paint(){var d=eta();var l=DN[d.getDay()]+', '+d.getDate()+' '+MN[d.getMonth()];if(l===shown)return;shown=l;
      document.querySelectorAll('[data-eta-date]').forEach(function(e){e.textContent=l});
      document.querySelectorAll('[data-eta]').forEach(function(e){e.classList.add('is-on')});}
    paint();setInterval(paint,60000);document.addEventListener('visibilitychange',function(){if(!document.hidden)paint()});
  })();

  /* ---------- Hero gallery: thumbnails switch the main slot; auto-advances every 5 s until he takes over ---------- */
  (function(){
    var main=document.getElementById('galMain'),cap=document.getElementById('galCap'),no=document.getElementById('galNo');
    var th=[].slice.call(document.querySelectorAll('[data-thumb]'));if(!main||th.length<2)return;
    var idx=0,timer=null,done=false,hover=false,onScreen=true;
    th.forEach(function(t){var s=t.getAttribute('data-src');if(s){var im=new Image();im.src=s}});
    function show(i){idx=(i+th.length)%th.length;th.forEach(function(t){t.removeAttribute('aria-current')});th[idx].setAttribute('aria-current','true');
      var src=th[idx].getAttribute('data-src');if(src&&main.getAttribute('src')!==src){main.setAttribute('src',src);main.setAttribute('alt',th[idx].getAttribute('data-alt')||'')}
      cap.innerHTML=th[idx].getAttribute('data-cap');no.textContent=('0'+(idx+1)).slice(-2)+'/'+('0'+th.length).slice(-2);}
    th.forEach(function(t,i){t.addEventListener('click',function(){done=true;stop();show(i)})});
    /* prev / next arrows, swipe on touch screens, arrow keys when focused */
    function go(d){done=true;stop();show(idx+d)}
    var pv=document.getElementById('galPrev'),nx=document.getElementById('galNext');
    if(pv)pv.addEventListener('click',function(){go(-1)});if(nx)nx.addEventListener('click',function(){go(1)});
    var sx=null,sy=null,mb=main.parentElement;
    mb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY},{passive:true});
    mb.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;sx=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))go(dx<0?1:-1)},{passive:true});
    mb.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){go(-1);e.preventDefault()}else if(e.key==='ArrowRight'){go(1);e.preventDefault()}});
    function step(){if(done||hover||!onScreen||document.hidden)return;show(idx+1)}
    function start(){if(!timer&&!done&&!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches))timer=setInterval(step,5000)}
    function stop(){if(timer){clearInterval(timer);timer=null}}
    var box=main.parentElement;box.addEventListener('mouseenter',function(){hover=true});box.addEventListener('mouseleave',function(){hover=false});
    if('IntersectionObserver' in window)new IntersectionObserver(function(e){onScreen=e[0].isIntersecting;if(onScreen)start();else stop()},{threshold:.15}).observe(box);
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start()});start();
  })();

  /* ---------- Meta Pixel: AddToCart on every checkout CTA (fires only if fbq is installed) ---------- */
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-checkout]');if(!a||typeof window.fbq!=='function')return;
    var k=a.getAttribute('data-checkout-fixed')||current;fbq('track','AddToCart',{content_name:'GLPro Core '+k+'-day',content_ids:['glpro-'+k],content_type:'product',value:PRICE[k],currency:'SGD'});});

  /* ---------- Evidence charts: hover / focus tooltip ---------- */
  (function(){
    var grid=document.querySelector('.cx-grid'); if(!grid) return;
    var tip=document.createElement('div'); tip.className='cx-tip'; tip.setAttribute('role','status'); document.body.appendChild(tip);
    function show(el){
      var t=el.querySelector('title'); if(!t) return;
      tip.textContent=t.textContent;
      var r=el.getBoundingClientRect();
      tip.classList.add('on');
      var tr=tip.getBoundingClientRect();
      var x=r.left+r.width/2-tr.width/2, y=r.top-tr.height-10;
      if(y<6){y=r.bottom+10}
      x=Math.max(8,Math.min(x,window.innerWidth-tr.width-8));
      tip.style.left=x+'px'; tip.style.top=y+'px';
    }
    function hide(){tip.classList.remove('on')}
    ['mouseover','focusin'].forEach(function(ev){grid.addEventListener(ev,function(e){
      var el=e.target.closest&&e.target.closest('.cx__pt,.cx__bar'); if(el){show(el)}})});
    ['mouseout','focusout'].forEach(function(ev){grid.addEventListener(ev,hide)});
    window.addEventListener('scroll',hide,{passive:true});
  })();

  /* ---------- Video wall: muted, plays only while on screen ---------- */
  (function(){
    var wall=document.querySelector('.vwall'); if(!wall) return;
    var vids=[].slice.call(wall.querySelectorAll('.vclip__v'));
    vids.forEach(function(v){v.muted=true;v.defaultMuted=true;v.setAttribute('muted','');});
    function play(){vids.forEach(function(v){v.muted=true;if(v.preload==='none'){v.preload='metadata';v.load();}var p=v.play();if(p&&p.catch)p.catch(function(){});});}
    function stop(){vids.forEach(function(v){v.pause()});}
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){es[0].isIntersecting?play():stop()},{threshold:.15}).observe(wall);
    }else{play()}
    document.addEventListener('visibilitychange',function(){document.hidden?stop():null});
  })();

  /* ---------- Sticky bar after hero ---------- */
  var hero=document.querySelector('.hero'),st=document.getElementById('sticky');
  if(st)st.classList.add('on'); /* sticky order bar is shown from first paint */

  /* ---------- Reveal ---------- */
  var secs=document.querySelectorAll('[data-arc] .sec-head, [data-arc] .card, [data-arc] .pcard, [data-arc] .fact, [data-arc] .alt, [data-arc] .how__c, [data-arc] .num');
  secs.forEach(function(el){el.classList.add('reveal')});
  if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.08});secs.forEach(function(el){io.observe(el)});setTimeout(function(){secs.forEach(function(el){el.classList.add('in')})},2500);}else{secs.forEach(function(el){el.classList.add('in')})}
})();

/* Chat with Felix: open/close, Contact pixel event */
(function(){
  var root=document.getElementById('fchat'); if(!root) return;
  var win=document.getElementById('fchatWin'), fab=document.getElementById('fchatFab'),
      close=document.getElementById('fchatClose');
  function store(k,v){try{ if(v===undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k,v);}catch(e){return null}}
  function open(){ win.hidden=false; root.classList.add('is-open'); fab.setAttribute('aria-expanded','true'); close.focus(); }
  function shut(){ win.hidden=true; root.classList.remove('is-open'); fab.setAttribute('aria-expanded','false'); fab.focus(); }
  fab.addEventListener('click',open);
  close.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !win.hidden) shut(); });
  root.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('[data-glpchat-go]'); if(!a) return;
    try{ if(window.fbq) fbq('track','Contact',{content_name:'Chat with Felix',method:a.getAttribute('data-glpchat-go')}); }catch(err){}
  });
})();

/* Floating offer bar: mobile pins from the first scroll; desktop slides in once the promo block is gone */
(function(){
  var fb=document.getElementById('floatbar'), promo=document.getElementById('promo');
  if(!fb) return;
  function lift(){ if(fb.parentElement!==document.body) document.body.appendChild(fb); }
  lift(); window.addEventListener('load',lift);
  function upd(){
    var mob=window.matchMedia('(max-width:900px)').matches;
    var y=window.pageYOffset||document.documentElement.scrollTop;
    var past=mob ? y>8 : (promo ? promo.getBoundingClientRect().bottom<-30 : y>120);
    fb.classList.toggle('on',past); fb.setAttribute('aria-hidden',String(!past));
  }
  window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
})();
});